import React, { createContext, useState, useContext } from 'react';
const NotificationsContext = createContext({});

export const NotificationProvider = ({ children }) => {
    const notificationCount = localStorage.getItem('notificationCount');
    const [notificationsCount, setNotificationsCount] = useState(notificationCount)
    const token = localStorage.getItem('authToken');

    const pusherKey = process.env.REACT_APP_PUSHER_KEY || process.env.REACT_APP_PUSHER_APP_KEY;
    const pusherCluster = process.env.REACT_APP_PUSHER_CLUSTER || process.env.REACT_APP_PUSHER_APP_CLUSTER;
    const customHost = (process.env.REACT_APP_PUSHER_HOST || '').trim();

    // Pusher Cloud: key + cluster only. Custom wsHost is for Soketi/self-hosted only.
    const options = {
        broadcaster: process.env.REACT_APP_PUSHER_BROADCASTER || 'pusher',
        key: pusherKey,
        cluster: pusherCluster,
        forceTLS: true,
        withCredentials: true,
        authEndpoint: `${process.env.REACT_APP_PUSHER_AUTH_URL}/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
    };

    if (customHost) {
        options.wsHost = customHost;
        options.wssHost = customHost;
        options.wsPort = Number(process.env.REACT_APP_PUSHER_PORT || 6001);
        options.wssPort = Number(process.env.REACT_APP_PUSHER_PORT || 443);
        options.forceTLS = process.env.REACT_APP_PUSHER_SCHEME !== 'http';
        options.useTLS = options.forceTLS;
    }

    return (
        <NotificationsContext.Provider
            value={{
                notificationsCount,
                setNotificationsCount,
                options
            }}
        >
            {children}
        </NotificationsContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationsContext);
